module.exports = {
  // BASE_API: "http://192.168.0.110:8080/boot-admin", // 颖姐
  // UploadFIL_EURL:'http://192.168.0.110:8080/boot-admin/upload',
  // BASE_ASSET_PATH: "http://192.168.0.110:81/file",
  // FILE_API:"http://192.168.0.4:81/file",

  // BASE_API: "http://192.168.0.4:8080/boot-admin", // 强哥
  // UploadFIL_EURL: 'http://192.168.0.4:8080/boot-admin/upload',
  // BASE_ASSET_PATH: "http://192.168.0.4:81/file",
  // FILE_API: "http://192.168.0.4:81/file"

  BASE_API: "https://tyj.ln.gov.cn/boot-admin", // 强哥
  UploadFIL_EURL: 'https://tyj.ln.gov.cn/boot-admin/upload',
  BASE_ASSET_PATH: "https://tyj.ln.gov.cn/loin/qmjshtFile",
  FILE_API: "https://tyj.ln.gov.cn/loin/qmjshtFile"
}

